import { render } from "./AccordionItem.vue?vue&type=template&id=701c7772"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/AccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "701c7772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701c7772', __exports__)) {
    api.reload('701c7772', __exports__)
  }
  
  module.hot.accept("./AccordionItem.vue?vue&type=template&id=701c7772", () => {
    api.rerender('701c7772', render)
  })

}


export default __exports__